import React from 'react';
import Typography from '@material-ui/core/Typography';
import TargetResultGauge from '../../../components/TargetResultGauge';
import gql from 'graphql-tag';
import get from 'lodash/get';
import { useQuery } from 'react-apollo-hooks';
import { AmplifyModelContext } from 'amplify-model-react';
import Divider from '@material-ui/core/Divider';
import { Map } from 'immutable';
import PeriodLabel from '../../../components/PeriodLabel';
import Message from '../../../components/Message';
const queryKey = 'MyTeamResults';

function useComposeMyResultQuery() {
  const { getModelSchema } = React.useContext(AmplifyModelContext);
  const modelSchema = getModelSchema('PeriodPlanResult');
  const modelFlatFields = modelSchema.basicFieldsString;
  return gql`
  query ${queryKey} ($memberId: ID!, $periodId: ID!) {
    getPeriod(id: $periodId){
      id
      name
      dateFrom  
      dateTo
      type
      description
    }
    getMember(id: $memberId) {
      id
      store {
        id
        members(limit: 999) {
          items {
            id
            planResults(limit: 200, filter: {periodPlanResultPeriodId: {eq: $periodId}}, sortDirection: DESC) {
              items {
                id
                periodPlanResultPeriodId
                periodPlanResultMemberId
                ${modelFlatFields}
              }
            }
          }
        }
      }
    }
  }
  
  `;
}

export default function PlanResults(props) {
  const { memberId, periodId } = props;
  const [state, setState] = React.useState(Map({ loading: true }));
  const query = useComposeMyResultQuery();
  const { data, loading } = useQuery(query, {
    variables: {
      memberId,
      periodId,
    },
    skip: !periodId,
    fetchPolicy: 'network-only',
  });
  React.useEffect(() => {
    if (!data) return;
    let myTeamPlanResults = [],
      myPlanResult;
    get(data, 'getMember.store.members.items', []).map(member => {
      const planResults = get(member, 'planResults.items', []);
      myTeamPlanResults = [...myTeamPlanResults, get(planResults, '0')];
      if (member.id === memberId) {
        myPlanResult = get(planResults, '0');
      }
    });
    setState(oldState =>
      oldState.merge({
        myTeamPlanResults,
        period: get(data, 'getPeriod'),
        myPlanResult,
        loading: false,
      }),
    );
  }, [data, memberId]);

  if (state.get('loading')) return <div>Loading..</div>;

  if (!periodId)
    return (
      <div>
        <center>
          <Message
            variant="warning"
            content={`No Data found.`}
            style={{ marginTop: 30, maxWidth: 200 }}
          />
        </center>
      </div>
    );

  console.log('>>MyResultsPage/PlanResults::', 'state.get', state.get('period')); //TRACE
  return (
    <div>
      <center>
        <Divider style={{ marginTop: 20 }} />
        <Typography variant="h5" style={{ marginTop: 20 }}>
          <PeriodLabel period={state.get('period')} />
        </Typography>
        <Divider style={{ marginTop: 15 }} />
        <Typography variant="h5" style={{ marginTop: 20 }}>
          My Targets
        </Typography>
        {state.has('myPlanResult') && (
          <TargetResultGauge periodPlanResults={[state.get('myPlanResult')]} />
        )}
        <Typography variant="h5" style={{ marginTop: 30 }}>
          Whole Team Targets
        </Typography>
        {state.has('myTeamPlanResults') && (
          <TargetResultGauge periodPlanResults={state.get('myTeamPlanResults')} />
        )}
      </center>
    </div>
  );
}
